import { Action } from '../../common/actions/core/action';

export class OpenDistantSalesAggreementAction implements Action {
  constructor(
    public onApprove: () => void,
    public saleType: string,
    public offerId?: string,
    public paymentType?: string
  ) {}
}



// WEBPACK FOOTER //
// src/app/buy/distant-sales-aggreement-dialog/distant-sales-aggreement-dialog.action.ts